/**
 * Multi-select tag filters voor de collectiepagina.
 *
 * De stock CollectionSection-klasse (theme.min.js) staat maar 1 actieve tag per
 * .Collapsible-groep toe: bij het selecteren van een nieuwe tag in dezelfde
 * groep wordt de vorige automatisch gedeselecteerd (zie _toggleTag). Dat is
 * onbruikbaar voor onze checkbox-filters, die juist meerdere tags binnen
 * dezelfde groep (en over groepen heen) tegelijk moeten kunnen combineren.
 *
 * Deze checkboxes hebben daarom geen data-action="toggle-tag" (zodat de stock
 * click-handler ze negeert) en worden hier zelfstandig afgehandeld: bij elke
 * wijziging wordt de volledige set aangevinkte tags verzameld en navigeert de
 * pagina naar de bijbehorende collectie-URL (native Shopify tag-intersectie
 * via "+"-gescheiden URL-segmenten), met behoud van de bestaande query string
 * (bv. sort_by).
 */
(function () {
  'use strict';

  function getCollectionBaseUrl() {
    var section = document.querySelector('[data-section-type="collection"]');

    if (!section) {
      return null;
    }

    try {
      var settings = JSON.parse(section.getAttribute('data-section-settings'));
      return settings.collectionUrl;
    } catch (e) {
      return null;
    }
  }

  function handleCheckboxChange() {
    var baseUrl = getCollectionBaseUrl();

    if (!baseUrl) {
      return;
    }

    var checked = document.querySelectorAll('.CheckboxFilterList__Input:checked');
    var tags = Array.prototype.map.call(checked, function (input) {
      return input.getAttribute('data-tag');
    });

    var url = baseUrl;

    if (tags.length > 0) {
      url += '/' + tags.join('+');
    }

    if (window.location.search) {
      url += window.location.search;
    }

    window.location.href = url;
  }

  document.addEventListener('change', function (event) {
    if (event.target.classList && event.target.classList.contains('CheckboxFilterList__Input')) {
      handleCheckboxChange();
    }
  });

  /**
   * Actieve filter chips: klikken op de ✕ verwijdert die ene tag uit de
   * huidige lijst (server-side gerenderd in section-settings als
   * "currentTags") en navigeert naar de collectie-URL zonder die tag, met
   * behoud van de overige tags en de query string.
   */
  document.addEventListener('click', function (event) {
    var chip = event.target.closest && event.target.closest('[data-action="remove-active-filter"]');

    if (!chip) {
      return;
    }

    var baseUrl = getCollectionBaseUrl();

    if (!baseUrl) {
      return;
    }

    var section = document.querySelector('[data-section-type="collection"]');
    var settings = JSON.parse(section.getAttribute('data-section-settings'));
    var currentTags = settings.currentTags || [];
    var tagToRemove = chip.getAttribute('data-tag');

    var remainingTags = currentTags.filter(function (tag) {
      return tag !== tagToRemove;
    });

    var url = baseUrl;

    if (remainingTags.length > 0) {
      url += '/' + remainingTags.join('+');
    }

    if (window.location.search) {
      url += window.location.search;
    }

    window.location.href = url;
  });

  /**
   * Prijsslider (dual-handle range) - filtert via Shopify's native
   * filter.v.price.gte / filter.v.price.lte URL-parameters. Deze werken op
   * elke collectiepagina server-side, ongeacht of het thema Shopify's
   * "Search & Discovery"-filterobject (collection.filters) gebruikt.
   */
  function initPriceRangeFilters() {
    var filters = document.querySelectorAll('.PriceRangeFilter');

    Array.prototype.forEach.call(filters, function (filter) {
      var minInput = filter.querySelector('.PriceRangeFilter__Input--min');
      var maxInput = filter.querySelector('.PriceRangeFilter__Input--max');
      var minLabel = filter.querySelector('.PriceRangeFilter__ValueMin');
      var maxLabel = filter.querySelector('.PriceRangeFilter__ValueMax');
      var rangeTrack = filter.querySelector('.PriceRangeFilter__Range');
      var applyButton = filter.querySelector('.PriceRangeFilter__Apply');
      var bounds = { min: Number(filter.dataset.min), max: Number(filter.dataset.max) };

      var params = new URLSearchParams(window.location.search);
      var urlMin = params.get('filter.v.price.gte');
      var urlMax = params.get('filter.v.price.lte');

      if (urlMin !== null) {
        minInput.value = urlMin;
      }

      if (urlMax !== null) {
        maxInput.value = urlMax;
      }

      function updateUi() {
        var minValue = Number(minInput.value);
        var maxValue = Number(maxInput.value);

        if (minValue > maxValue) {
          minValue = maxValue;
          minInput.value = minValue;
        }

        minLabel.textContent = minValue + ' €';
        maxLabel.textContent = maxValue + ' €';

        var min = bounds.min;
        var max = bounds.max;
        var range = max - min || 1;
        var left = ((minValue - min) / range) * 100;
        var right = ((maxValue - min) / range) * 100;

        rangeTrack.style.left = left + '%';
        rangeTrack.style.right = (100 - right) + '%';
      }

      minInput.addEventListener('input', updateUi);
      maxInput.addEventListener('input', updateUi);

      applyButton.addEventListener('click', function () {
        var baseUrl = getCollectionBaseUrl();

        if (!baseUrl) {
          return;
        }

        var checked = document.querySelectorAll('.CheckboxFilterList__Input:checked');
        var tags = Array.prototype.map.call(checked, function (input) {
          return input.getAttribute('data-tag');
        });

        var url = baseUrl;

        if (tags.length > 0) {
          url += '/' + tags.join('+');
        }

        var newParams = new URLSearchParams(window.location.search);
        newParams.set('filter.v.price.gte', minInput.value);
        newParams.set('filter.v.price.lte', maxInput.value);

        url += '?' + newParams.toString();

        window.location.href = url;
      });

      updateUi();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPriceRangeFilters);
  } else {
    initPriceRangeFilters();
  }

  /**
   * "Mehr lesen / Weniger anzeigen" voor de collectiebeschrijving onder het
   * productgrid. Puur CSS max-height-transitie; JS schakelt alleen de klasse
   * en de knoptekst.
   */
  document.addEventListener('click', function (event) {
    var toggle = event.target.closest && event.target.closest('[data-action="toggle-collection-description"]');

    if (!toggle) {
      return;
    }

    var description = toggle.parentElement.querySelector('[data-collection-description]');
    var moreText = toggle.querySelector('[data-toggle-text-more]');
    var lessText = toggle.querySelector('[data-toggle-text-less]');
    var isExpanded = description.classList.toggle('is-expanded');

    moreText.style.display = isExpanded ? 'none' : '';
    lessText.style.display = isExpanded ? '' : 'none';
  });

  function hideToggleIfNotClamped() {
    var description = document.querySelector('[data-collection-description]');
    var toggle = document.querySelector('[data-action="toggle-collection-description"]');

    if (!description || !toggle) {
      return;
    }

    if (description.scrollHeight <= description.clientHeight + 4) {
      toggle.style.display = 'none';
      description.style.maxHeight = 'none';
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hideToggleIfNotClamped);
  } else {
    hideToggleIfNotClamped();
  }
})();
